import { render } from "./resetLOConfirmModal.vue?vue&type=template&id=3831b1a2"
import script from "./resetLOConfirmModal.vue?vue&type=script&lang=js"
export * from "./resetLOConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__